export const heroCrumbSprites = [
  'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/28afdfdf-3e7b-4ede-9fcf-ae42c6f50add_crumb-baked-1.webp',
  'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/28afdfdf-3e7b-4ede-9fcf-ae42c6f50add_crumb-baked-2.webp',
  'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/28afdfdf-3e7b-4ede-9fcf-ae42c6f50add_crumb-baked-3.webp',
  'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/28afdfdf-3e7b-4ede-9fcf-ae42c6f50add_crumb-baked-4.webp',
  'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/28afdfdf-3e7b-4ede-9fcf-ae42c6f50add_crumb-baked-5.webp',
];

// Deterministic crumb flights around the croissant's outline, px at a 1100px-wide product box (scaled at runtime).
// s = sprite, w = width, a = emit angle on the croissant ellipse (0 = right, 90 = bottom, 180 = left, 270 = top),
// dist = outward travel, up = extra rise, fall = drop at end, r = spin, t = lifetime, d = delay, m = keep on mobile
export const heroCrumbFlights = [
  { s: 0, w: 78, a: 182, dist: 300, up: 150, fall: 260, r: -320, t: 1.25, d: 0, m: true },
  { s: 1, w: 64, a: 352, dist: 280, up: 170, fall: 240, r: 360, t: 1.2, d: 0.01, m: true },
  { s: 2, w: 52, a: 215, dist: 240, up: 210, fall: 220, r: -420, t: 1.1, d: 0.02, m: true },
  { s: 3, w: 46, a: 325, dist: 260, up: 220, fall: 230, r: 300, t: 1.15, d: 0.02, m: true },
  { s: 0, w: 58, a: 160, dist: 220, up: 110, fall: 250, r: 260, t: 1.05, d: 0.03, m: true },
  { s: 4, w: 36, a: 20, dist: 230, up: 120, fall: 240, r: -280, t: 1.0, d: 0.01, m: true },
  { s: 1, w: 40, a: 250, dist: 160, up: 260, fall: 200, r: 380, t: 1.15, d: 0.04, m: true },
  { s: 2, w: 34, a: 295, dist: 170, up: 240, fall: 210, r: -340, t: 1.1, d: 0.03, m: true },
  { s: 3, w: 30, a: 140, dist: 180, up: 70, fall: 220, r: 240, t: 0.95, d: 0.05, m: true },
  { s: 4, w: 28, a: 40, dist: 190, up: 80, fall: 230, r: -220, t: 0.95, d: 0.04, m: true },
  { s: 0, w: 44, a: 200, dist: 340, up: 90, fall: 280, r: 420, t: 1.3, d: 0.06, m: false },
  { s: 1, w: 38, a: 340, dist: 330, up: 100, fall: 270, r: -400, t: 1.3, d: 0.05, m: false },
  { s: 2, w: 26, a: 230, dist: 200, up: 180, fall: 200, r: 300, t: 1.0, d: 0.07, m: false },
  { s: 3, w: 24, a: 310, dist: 210, up: 190, fall: 200, r: -260, t: 1.0, d: 0.06, m: false },
  { s: 4, w: 22, a: 115, dist: 140, up: 50, fall: 180, r: 200, t: 0.85, d: 0.08, m: false },
  { s: 4, w: 20, a: 65, dist: 150, up: 60, fall: 190, r: -200, t: 0.85, d: 0.07, m: false },
];

// Diffuse heat vapor: two seamless tiling noise fields + one emission mask traced from the croissant's upper rim.
export const heroVapor = {
  noise: [
    'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/ba1bda49-9541-45fe-8ba4-aad59943f290_vapor-noise-3.webp',
    'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/ba1bda49-9541-45fe-8ba4-aad59943f290_vapor-noise-4.webp',
  ],
  // Traced from the hero photo's real upper silhouette (top ≈ 16.7% of box at centre), spans box x 4–96%, y -16–60%.
  mask: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/ba1bda49-9541-45fe-8ba4-aad59943f290_vapor-mask-2.png',
};

export const heroImage = {
  src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_hero-croissant.webp',
  alt: 'A single hand-laminated FOLD. croissant lit from the side on a black stage',
};

export const collection = [
  {
    name: 'The Classic Croissant',
    note: 'Twenty-seven butter layers, a shattering crust and a honeyed, open crumb.',
    price: '$5.50',
    category: 'Croissants',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_col-croissant.webp',
  },
  {
    name: 'Country Sourdough',
    note: 'Naturally leavened over 24 hours. Blistered crust, glossy crumb.',
    price: '$9.00',
    category: 'Bread',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_col-sourdough.webp',
  },
  {
    name: 'Kouign-Amann',
    note: 'Caramelised edges, a soft salted centre. Baked dark on purpose.',
    price: '$6.50',
    category: 'Pastries',
    src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_col-kouign.webp',
  },
];

export const menuImage = {
  src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_menu-rack.webp',
  alt: 'A tray of freshly baked laminated pastries going onto the bakery rack',
};

export const signatureMenu = [
  { name: 'Classic Croissant', description: 'Hand-laminated over three days with cultured butter. Crisp, then weightless.', price: '$5.50', meta: 'Contains: gluten, dairy, egg' },
  { name: 'Pain au Chocolat', description: 'Two batons of dark chocolate folded into twenty-seven layers.', price: '$6.00', meta: 'Contains: gluten, dairy, egg, soy' },
  { name: 'Kouign-Amann', description: 'Caramelised, salted centre, edges baked to a deep amber.', price: '$6.50', meta: 'Contains: gluten, dairy' },
  { name: 'Almond Croissant', description: 'Twice-baked, filled with frangipane and finished with flaked almonds.', price: '$7.00', meta: 'Contains: gluten, dairy, egg, nuts' },
  { name: 'Country Sourdough', description: 'Naturally leavened, stone-deck baked, blistered and dark.', price: '$9.00', meta: 'Contains: gluten' },
  { name: 'Seeded Rye', description: 'Toasted seeds, cracked grain and a malty, close crumb.', price: '$10.50', meta: 'Contains: gluten, sesame' },
];

export const timelineCroissant = {
  src: 'https://readdy.ai/api/search-image?query=A%20single%20golden%20butter%20croissant%20isolated%20on%20a%20plain%20warm%20ivory%20off-white%20seamless%20background%2C%20side%20profile%20view%2C%20soft%20even%20studio%20light%2C%20crisp%20detailed%20laminated%20layers%2C%20very%20soft%20shadow%20beneath%2C%20clean%20minimal%20product%20photography%2C%20realistic%20natural%20colours&width=800&height=600&seq=fold-timeline-croissant-01&orientation=landscape',
  alt: 'A whole FOLD. croissant on the morning timeline',
};

export const timelineStates = [
  { key: 'whole', src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_donut-whole.webp', alt: 'A whole FOLD. glazed donut, freshly made' },
  { key: 'bite', src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_donut-bite.webp', alt: 'The same donut with one bite missing' },
  { key: 'half', src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_donut-half.webp', alt: 'The same donut, half eaten' },
  { key: 'quarter', src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_donut-quarter.webp', alt: 'The same donut with about a quarter remaining' },
  { key: 'crumbs', src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_donut-crumbs.webp', alt: 'The last crumbs of the donut' },
];

export const timeline = [
  { time: '07:00', label: 'Out of the oven, still crackling', state: 'Freshly baked', frame: 0 },
  { time: '08:30', label: 'The first shattering bite', state: 'First bite', frame: 1 },
  { time: '10:00', label: 'Half gone with the second coffee', state: 'Half gone', frame: 2 },
  { time: '13:00', label: 'One last corner, saved for later', state: 'A quarter left', frame: 3 },
  { time: '15:00', label: 'Gone until tomorrow', state: 'Last crumbs', frame: 4 },
];

export const craftImages = {
  hands: {
    src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_craft-hands.webp',
    alt: 'A baker folding a sheet of laminated dough on a floured bench',
  },
  lamination: {
    src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_craft-lamination.webp',
    alt: 'Cut cross-section of raw laminated dough showing butter layers',
  },
  finished: {
    src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_craft-finished.webp',
    alt: 'Freshly baked croissants cooling on a dark tray',
  },
};

export const visitImage = {
  src: 'https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_visit-counter.webp',
  alt: 'The FOLD. counter with sourdough loaves on pale shelves',
};

export const visitInfo = {
  address: '218 Valencia St, San Francisco, CA',
  phone: '(415) 555-0142',
  hours: [
    { day: 'Tue – Fri', time: '7:00 – 15:00' },
    { day: 'Saturday', time: '7:00 – 16:00' },
    { day: 'Sunday', time: '8:00 – 13:00' },
    { day: 'Monday', time: 'Closed' },
  ],
};

export const navLinks = [
  { href: '/collection', label: 'Collection' },
  { href: '/story', label: 'Our Craft' },
  { href: '/visit', label: 'Visit' },
];